import * as React from 'react';
import { useIntl } from 'react-intl';

import {
  DrawerContext,
  IconRegularWoman,
  ButtonModel,
} from '@notino/react-styleguide';

import { MultistepModal } from '@components/MultistepModal';
import { withProviders } from '@context/contextConfig';

import { useScreenResizeChangeContainer } from './hooks/useScreenResizeChangeContainer';
import { useShadefinder } from './hooks/useShadefinder';
import { messages } from './messages';
import { ButtonShadefinderWrapper } from './styled';

interface IShadefinderProps {
  masterId: string;
}

const ShadefinderComponent: React.FC<IShadefinderProps> = ({ masterId }) => {
  const { formatMessage } = useIntl();
  const openShadefinder = useShadefinder(masterId);

  useScreenResizeChangeContainer();

  return (
    <ButtonShadefinderWrapper
      buttonStyle={ButtonModel.Styles.secondary}
      onClick={openShadefinder}
    >
      <IconRegularWoman />

      {formatMessage(messages.chooseYourVariant)}
    </ButtonShadefinderWrapper>
  );
};

export default withProviders<IShadefinderProps & Record<string, unknown>>(
  DrawerContext.Provider,
  MultistepModal.Provider
)(ShadefinderComponent);
